import { useEffect } from 'react';

export function useTitle(
  title: string,
  searchQuery?: any,
  inputError?: string
) {
  useEffect(() => {
    return () => {
      if (searchQuery && !inputError) {
        document.title = `${searchQuery} | ${title}`;
      } else {
        document.title = title;
      }
    };
  });
}
